export default __webpack_public_path__ + "static/media/MONETA_BLYSK.7047ba5a.gif";